import cx from 'classnames'
import * as _ from 'lodash'
import React, { useEffect, useState } from 'react'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import { useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router'
import './ManageAccessRights.scss'
import { Box, Button, Typography } from '@mui/material'

import {
  getCourseClassesById,
  getUserGroupById,
  updateUserGroupById,
  updateCourseClassesById,
  getAllModulesSubgroups,
} from '@/store/knowledge/actions'

import { useTranslation } from 'react-i18next'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import Toggle from '@/components/UI/Toggle'

const ManageAccessRights = () => {
  const { t } = useTranslation('translation')
  const history = useHistory()
  const dispatch = useDispatch()
  const params: any = useParams()
  const [loading, setLoading] = useState(false)
  const [entity, setEntity] = useState<any>(null)
  const [multipleClasses, setMultipleClasses] = useState<any>([])
  const [selectedGroupId, setSelectedGroupId] = useState<any>([])

  const [allGroups, setAllGroups] = useState([])
  const [accessAllKnowledge, setAccessAllKnowledge] = useState(false)

  useEffect(() => {
    setSelectedGroupId([])
    getAllGroups()
    handleModulesCall(params)
  }, [])

  const getAllGroups = async () => {
    try {
      const response: any = await dispatch(getAllModulesSubgroups())
      setAllGroups(
        Array.isArray(response)
          ? response.filter((g: any) => g?.group_type !== 'system')
          : [],
      )
    } catch (error: any) {
      setAllGroups([])
    }
  }

  const handleModulesCall = async ({
    id,
    type,
  }: {
    id?: string
    type?: string
  }) => {
    setLoading(true)
    if (type === 'learner') {
      try {
        const response: any = await dispatch(getUserGroupById(id))
        setAccessAllKnowledge(response.access_all_knowledge)
        setSelectedGroupId(
          response.knowledge_groups
            ? [...response.knowledge_groups.map((g: any) => g._id)]
            : [],
        )
        setEntity(response)
      } catch (error: any) {
        setEntity(null)
      }
    } else {
      const query = new URLSearchParams(history.location.search)
      let classes = query.get('classes')
        ? query.get('classes').split(',')
        : null

      try {
        if (classes) {
          let entities: any = []
          for await (const iterator of classes) {
            const response: any = await dispatch(getCourseClassesById(iterator))
            entities.push(response)
          }
          setMultipleClasses(entities)
        } else {
          const response: any = await dispatch(getCourseClassesById(id))
          setAccessAllKnowledge(response.access_all_knowledge)
          setSelectedGroupId(
            response.knowledge_group_ids
              ? [...response.knowledge_group_ids]
              : [],
          )
          setEntity(response)
        }
      } catch (error: any) {
        setEntity(null)
      }
    }
    setLoading(false)
  }

  const handleUpdate = async () => {
    setLoading(true)
    if (params.type === 'learner') {
      try {
        const response: any = await dispatch(
          updateUserGroupById(entity._id, selectedGroupId, accessAllKnowledge),
        )
        setEntity(response)
        setLoading(false)
      } catch (error: any) {
        setEntity(null)
        setLoading(false)
      }
    } else {
      try {
        if (multipleClasses.length) {
          let enetities: any = []
          let count = 1
          for await (const iterator of multipleClasses) {
            const response: any = await dispatch(
              updateCourseClassesById(
                iterator._id,
                selectedGroupId,
                accessAllKnowledge,
                count === multipleClasses.length,
              ),
            )
            enetities.push(response)
            ++count
          }
          setMultipleClasses(enetities)
          setLoading(false)
        } else {
          const response: any = await dispatch(
            updateCourseClassesById(
              entity._id,
              selectedGroupId,
              accessAllKnowledge,
            ),
          )
          setEntity(response)
          setLoading(false)
        }
      } catch (error: any) {
        setEntity(null)
        setLoading(false)
      }
    }
    setLoading(false)
  }

  const chooseCategoryHandler = (e: any) => {
    const isPresentIndex = selectedGroupId.indexOf(e.target.value)
    const oldSelectedOptions = [...selectedGroupId]
    const childrensArray: string[] = []
    const func = (value: string) => {
      const childrens = allGroups.filter((p: any) => p.parent_id === value)
      if (childrens.length) {
        childrens.forEach(d => {
          func(d.value)
        })
      }
      childrensArray.push(value)
    }
    func(e.target.value)

    if (e.target.checked && isPresentIndex === -1) {
      oldSelectedOptions.push(e.target.value)
      return setSelectedGroupId(
        _.uniq(oldSelectedOptions.concat(childrensArray)),
      )
    }

    if (!e.target.checked && isPresentIndex >= 0) {
      oldSelectedOptions.splice(isPresentIndex, 1)
      childrensArray.forEach((id: string) => {
        const isPresentIndex = _.uniq(oldSelectedOptions).indexOf(id)
        if (isPresentIndex >= 0) {
          oldSelectedOptions.splice(isPresentIndex, 1)
        }
      })
      return setSelectedGroupId(_.uniq(oldSelectedOptions))
    }
  }

  const accessAllKnowledgeChangedHandler = (e: any) => {
    setAccessAllKnowledge(e.target.checked)
  }

  return (
    <section
      className={cx({
        'page-mid-wraper user-groups pb-0': true,
        hidden: loading,
      })}
    >
      <div>
        <ChildPageHeader
          title={t('Manage Access Rights')}
          subTitle={t(
            'Manage users and grant access and decide which of the content they can access',
          )}
          slot={{
            action: (
              <Button
                variant="contained"
                size="medium"
                disabled={false}
                onClick={() => handleUpdate()}
              >
                {t('Update')}
              </Button>
            ),
          }}
        />
        <div className="classHeader">
          <div>
            <h3>
              {params && params.type === 'learner' ? t('Group') : t('Class')}
            </h3>
            <h2>
              {multipleClasses.length
                ? multipleClasses.map((cl: any) => cl.name).join(', ')
                : entity && entity?.name}
            </h2>
          </div>
        </div>

        <div className="pref-check mt-4 notify-onOff switch-blue">
          <Toggle
            toggled={accessAllKnowledge}
            onToggle={accessAllKnowledgeChangedHandler}
            label={t('Allow Access to all knowledge?')}
            InputPosition="end"
          />
        </div>

        <Box className="modulesContainer">
          <div className="header">
            <Typography variant="h3">{t('Groups')}</Typography>
            <Typography variant="h3">{t('Can Access')}</Typography>
          </div>
          <div className="modules-list flex-grow-1">
            <ul className="">
              {allGroups &&
                allGroups.map((mod: any) => {
                  return (
                    <li
                      key={'child_padding_dev_' + mod.value}
                      style={{
                        paddingLeft: `${
                          mod.depth > 0 ? mod.depth * 10 + 10 : 10
                        }px`,
                      }}
                      className={cx({
                        'clr-grey-txt': mod.depth > 0,
                        disabled:
                          accessAllKnowledge ||
                          selectedGroupId.indexOf(mod.parent_id) >= 0,
                        // active: selectedGroupId === mod.value,
                      })}
                    >
                      <div className="moduleContainer">
                        <h3>{mod.label}</h3>
                        <input
                          type="checkbox"
                          value={mod.value}
                          disabled={
                            accessAllKnowledge ||
                            selectedGroupId.indexOf(mod.parent_id) >= 0
                          }
                          checked={
                            selectedGroupId.indexOf(mod.value) >= 0 ||
                            accessAllKnowledge ||
                            selectedGroupId.indexOf(mod.parent_id) >= 0
                          }
                          onChange={chooseCategoryHandler}
                        />
                      </div>
                    </li>
                  )
                })}
            </ul>
          </div>
        </Box>
      </div>
    </section>
  )
}
export default ManageAccessRights
